export enum ProcedureValidatorErrorEnum {
    OVER_LIMIT = 'OVER_LIMIT',
    MISSING_PROCEDURE_80090_80091 = 'MISSING_PROCEDURE_80090_80091',
    MISSING_DOCTOR_RECORD = 'MISSING_DOCTOR_RECORD',
    NEW_PROCEDURE_ON_VOUCHER = 'NEW_PROCEDURE_ON_VOUCHER',
    UNPRESCRIBED_PROCEDURE = 'UNPRESCRIBED_PROCEDURE',
    NOT_ALLOWED_CODE = 'NOT_ALLOWED_CODE',
    DENIED_CODE = 'DENIED_CODE',
}

export const STRATEGY_PROCESSED_ERRORS = [
    ProcedureValidatorErrorEnum.OVER_LIMIT,
    ProcedureValidatorErrorEnum.NOT_ALLOWED_CODE,
    ProcedureValidatorErrorEnum.DENIED_CODE,
];
